import { Loadable } from '../../Loadable';

export { OrderSearch } from './search';
export { OrdersList } from './List';
export { ChangeOrderUser } from './ChangeUser';
export { UpdateOrder } from './UpdateOrder';
export { ConfirmOrder } from './ConfirmOrder';
export const AsyncResendReceipt = Loadable(() => import('./ResendReceipt'));
export const AsyncManageIndividualOrder = Loadable(() => import('./ManageIndividualOrder'));
